var _path, _mask, _path2, _mask2, _path3, _path4, _path5, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoeRack = function SvgShoeRack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M2.5 18V2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v16a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5ZM15.5 18V2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v16a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "shoe-rack_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 16.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 16v1h11v-2h-11zm11 1v-1h-11v2h11zm-11 0v-1a.5.5 0 0 1 .5.5H3A1.5 1.5 0 0 0 4.5 18zm11.5-.5h-1a.5.5 0 0 1 .5-.5v2a1.5 1.5 0 0 0 1.5-1.5zm-.5-.5v1a.5.5 0 0 1-.5-.5h2a1.5 1.5 0 0 0-1.5-1.5zm-11 0v-1A1.5 1.5 0 0 0 3 16.5h2a.5.5 0 0 1-.5.5z",
    mask: "url(#shoe-rack_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "shoe-rack_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 8v1h11V7h-11zm11 1V8h-11v2h11zm-11 0V8a.5.5 0 0 1 .5.5H3A1.5 1.5 0 0 0 4.5 10zM16 8.5h-1a.5.5 0 0 1 .5-.5v2A1.5 1.5 0 0 0 17 8.5zm-.5-.5v1a.5.5 0 0 1-.5-.5h2A1.5 1.5 0 0 0 15.5 7zm-11 0V7A1.5 1.5 0 0 0 3 8.5h2a.5.5 0 0 1-.5.5z",
    mask: "url(#shoe-rack_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.75 8V6.8c0-.443.16-.916.417-1.27C7.428 5.168 7.733 5 8 5s.572.169.833.53c.257.354.417.827.417 1.27V8a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5ZM10.75 8V6.8c0-.443.16-.916.417-1.27.261-.361.566-.53.833-.53s.572.169.833.53c.257.354.417.827.417 1.27V8a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M7 16.5V12.49c0-.535.42-.98.953-1.016.716-.049 1.46-.086 2.047.027.711.138-.286 2.5 2 2.5 1.785 0 2 1.236 2 1.5v1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 10.68,
    y: 12.979,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-43.595 10.68 12.979)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    fill: "currentColor",
    rx: 0.5,
    transform: "matrix(1 -.00079 -.00079 -1 9 14.002)"
  })));
};
export default SvgShoeRack;